import { Box, BoxProps } from "@mui/material";
import React from "react";

export type NoPropagateBoxProps = React.PropsWithChildren<BoxProps> & {
  // Defaults to true (historical behaviour). Set to false when wrapping
  // Lexical-based editors that need the default click to position the caret.
  preventDefault?: boolean;
};

export const NoPropagateBox = ({
  children,
  onKeyDown,
  onMouseDown,
  onTouchStart,
  onClick,
  preventDefault = true,
  ...props
}: NoPropagateBoxProps) => {
  return (
    <Box
      onMouseDown={e => {
        e.stopPropagation();
        onMouseDown?.(e);
      }}
      onTouchStart={e => {
        e.stopPropagation();
        onTouchStart?.(e);
      }}
      onClick={e => {
        if (preventDefault) e.preventDefault();
        e.stopPropagation();
        onClick?.(e);
      }}
      onKeyDown={e => {
        if (e.key === "Tab") {
          return;
        }
        e.stopPropagation();
        onKeyDown?.(e);
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
